import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper } from '@material-ui/core';
import { HelpUserMachine } from '../../UserMachine/utils/HelpUserMachine';


const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    card: {
        padding: theme.spacing(3),
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        height: '80px',
        marginTop: '-1%',
        marginBottom: '2%'
    }
}));




export default function ListUserDetail({ pageBascula, fechaIni, fechaFin, rows, isLoadUser, page, size, totalElement, setPage }) {

    const classes = useStyles();

    const calcularEdad = (fecha) => {
        var hoy = new Date();
        var cumpleanos = new Date(fecha);
        var edad = hoy.getFullYear() - cumpleanos.getFullYear();
        var m = hoy.getMonth() - cumpleanos.getMonth();

        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }

        return edad;
    }

    const validateRowsTable = (item) => {

        if (item !== undefined && item !== null) {
            return item
        } else {
            return "---"
        }

    }

    const r = rows !== undefined && rows !== null ? rows.sort((a, b) => a.ies < b.ies ? 1 : -1) : []

    return (
        <>

            {isLoadUser ? <>cargando...</> : r.map((row) => (
                <Paper className={classes.card}>
                    <Grid container spacing={1}>
                        <Grid item style={{ width: '11%', fontWeight: "bold", fontSize: '17px' }}>
                            {validateRowsTable(row.numerodocumento)}
                        </Grid>
                        <Grid style={{ width: '13%', fontWeight: "bold", fontSize: '17px', paddingRight: "2%" }}>
                            {validateRowsTable(row.firstname)}
                        </Grid>
                        <Grid style={{ width: '12%', fontWeight: "bold", fontSize: '17px' }}>
                            {validateRowsTable(row.celular)}
                        </Grid>
                        <Grid style={{ width: '6%', fontWeight: "bold", fontSize: '17px' }}>
                            {validateRowsTable(row.genero)}
                        </Grid>
                        <Grid style={{ width: '7%', fontWeight: "bold", fontSize: '17px' }}>
                            {validateRowsTable(row.peso)}
                        </Grid>
                        <Grid style={{ width: '8%', fontWeight: "bold", fontSize: '17px' }}>
                            {validateRowsTable(row.altura)}
                        </Grid>
                        <Grid style={{ width: '9.5%', fontWeight: "bold", fontSize: '17px' }} >
                            {` ${validateRowsTable(row.sistolica)}/${validateRowsTable(row.diastolica)}`}
                        </Grid>
                        <Grid style={{ width: '8%', fontWeight: "bold", fontSize: '17px' }}>
                            {validateRowsTable(row.imc == null ? row.imc : row.imc.toFixed(1))}
                        </Grid>
                        <Grid style={{ width: '7%', fontWeight: "bold", fontSize: '17px' }} >
                            {validateRowsTable(row.igc == null ? row.igc : row.igc.toFixed(1))}
                        </Grid>
                        <Grid style={{ width: '8%', fontWeight: "bold", fontSize: '17px', paddingLeft: '2%' }} >
                            {validateRowsTable(row.oximetria == null ? row.oximetria : row.oximetria.toFixed(1))}
                        </Grid>
                        <Grid style={{ width: '1%', fontWeight: "bold", fontSize: '17px' }}  >
                            {validateRowsTable(calcularEdad(row.edad))}
                        </Grid>
                        <Grid style={{ width: '2%', fontWeight: "bold", fontSize: '17px', marginLeft: '3%' }}  >
                            {HelpUserMachine().selectIconIes(row.ies)}
                        </Grid>
                    </Grid>
                </Paper>
            ))}

        </>
    );


}